"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NavBarLogo = void 0;
const react_1 = __importDefault(require("react"));
const svgs_1 = require("../assets/svgs");
const material_1 = require("@mui/material");
function NavBarLogo({ app, sx, ...rest }) {
    const defaultSX = {};
    const mergedSX = { ...defaultSX, ...sx };
    return (react_1.default.createElement(material_1.Button, { sx: mergedSX, ...rest }, getBrand(app)));
}
exports.NavBarLogo = NavBarLogo;
function getBrand(app) {
    switch (app) {
        case 'PopStudy':
            return react_1.default.createElement(svgs_1.PopStudyBrandWhite, { className: "h-[1.99rem] sm:w-auto" });
        case 'PopQuiz':
            return react_1.default.createElement(svgs_1.PopQuizBrandWhite, { className: "h-[1.99rem] sm:w-auto" });
        case 'PopTeams':
            return react_1.default.createElement(svgs_1.PopTeamsBrandWhite, { className: "h-[1.99rem] sm:w-auto" });
        case 'PopStack':
            return react_1.default.createElement(svgs_1.PopStackBrandWhite, { className: "h-[1.99rem] sm:w-auto" });
    }
}
